import DataList from "../../../component/DataList";
import { useEffect, useMemo, useRef, useState } from "react";
import { Description, Sorter } from "../../../component/DataList/schema";
import instance from "../../../util/axios";
import dayjs from "dayjs";
import { Toast } from "antd-mobile";
import {
  Avatar,
  Button,
  CalendarPickerView,
  Modal,
  NavBar,
  Popup,
  Space,
  Tag,
  TextArea,
} from "antd-mobile-v5";
// import "react-big-calendar/lib/css/react-big-calendar.css";
import { CalendarOutline } from "antd-mobile-icons";

const sorter: Sorter = {
  field: "createTime",
  order: "descend",
};
export default function () {
  const [sessionInfo, setSessionInfo] = useState<{
    userId: string;
    name: string;
  }>({ userId: "", name: "" });
  const [permissions, setPermissions] = useState<string[]>([]);

  useEffect(() => {
    instance.get(`/crm/user/`).then((resp) => {
      setSessionInfo(resp.data.Data);
    });

    instance.get(`/oa/user/getUserPermission`).then((resp) => {
      setPermissions(resp.data.Data);
    });
  }, []);
  const listRef = useRef<any>();
  const [categories, setCategories] = useState<any[]>([]);
  const [date, setDate] = useState("");
  const [reportDates, setReportDates] = useState<string[]>([]);
  const [currentReport, setCurrentReport] = useState<{
    uuid: string;
    date: string;
    details: {
      categoryId: string;
      content: string;
    }[];
  }>();
  const [calendarModal, setCalendarModal] = useState(false);
  const [reportModal, setReportModal] = useState<{
    open: boolean;
    uuid?: string;
    date?: string;
    details: {
      categoryId: string;
      content: string;
      focus?: boolean;
    }[];
  }>({
    open: false,
    details: [],
  });
  useEffect(() => {
    // 获取今天的日报，用于判断点击新建按钮时是否需要跳转到编辑界面
    // getCurrentDailyReport
    instance.get("/custom/laiensi/getCurrentDailyReport").then((res) => {
      if (!res.data.Data) {
        return;
      }
      setCurrentReport(res.data.Data);
    });

    // 获取上月到今天的有日报的日期
    // getReportDates
    instance
      .get(
        "/custom/laiensi/getReportDates?startDate=" +
          dayjs().subtract(50, "year").format("YYYY-MM-DD") +
          "&endDate=" +
          dayjs().format("YYYY-MM-DD")
      )
      .then((res) => {
        setReportDates(res.data.Data);
      });

    // 获取所有的日报类别
    // /crm/dictConfig/getDictItemList?tableName=oa_daily_report_lions_detail_category
    instance
      .get(
        "/crm/dictConfig/getDictItemList?tableName=oa_daily_report_lions_detail_category&pageSize=1000"
      )
      .then((res) => {
        setCategories(res.data.Data.data);
      });
  }, []);

  const descriptions: Description[] = useMemo(
    () => [
      {
        fieldShowName: "创建人",
        fieldName: "creatorId",
        inputType: 6,
        dictionary: "base_staff",
      },
      {
        fieldShowName: "内容",
        fieldName: "content",
      },
    ],
    []
  );
  return (
    <>
      <DataList
        extra={
          <Button
            fill={"none"}
            onClick={() => {
              setCalendarModal(true);
            }}
          >
            <CalendarOutline />
          </Button>
        }
        sorter={sorter}
        ref={listRef}
        descriptions={descriptions}
        url={`/custom/laiensi/getDailyReportList?date=${date}`}
        render={(record: any) => (
          <>
            <div className={"flex w-full items-center"}>
              <div className={"p-4 w-full gap-4 flex flex-col flex-1"}>
                <div className={"flex items-center justify-between w-full"}>
                  <div className={"font-bold text-lg"}>{record.date}</div>
                  <Space>
                    {/* 编辑 */}
                    <Button
                      fill={"none"}
                      size={"small"}
                      disabled={
                        record.date !== dayjs().format("YYYY-MM-DD") ||
                        sessionInfo.userId !== record.ref.creatorId
                      }
                      onClick={(event) => {
                        event.stopPropagation();
                        setReportModal({
                          ...reportModal,
                          open: true,
                          uuid: record.uuid,
                          date: record.date,
                          details: record.details.map((item: any) => ({
                            categoryId: item.categoryId,
                            content: item.content,
                          })),
                        });
                      }}
                    >
                      编辑
                    </Button>

                    {permissions.includes("删除莱恩斯工作日志") ? (
                      <Button
                        fill={"none"}
                        size={"small"}
                        color={"danger"}
                        onClick={(event) => {
                          event.stopPropagation();
                          Modal.confirm({
                            title: "确认删除吗？",
                            onConfirm() {
                              instance
                                .delete(
                                  "/custom/laiensi/deleteDailyReport?uuid=" +
                                    record.uuid
                                )
                                .then((res) => {
                                  if (res.data.Status === "1") {
                                    Toast.success("删除成功");
                                    listRef.current?.refresh();
                                  } else {
                                    Toast.fail("删除失败");
                                  }
                                });
                            },
                          });
                        }}
                      >
                        删除
                      </Button>
                    ) : (
                      <></>
                    )}
                  </Space>
                </div>
                <div
                  className={"text-gray-500 flex gap-2 items-center self-start"}
                >
                  <Avatar className={"w-4 h-4"} src={"/defaultAvatar.png"}>
                    {record.creatorId}
                  </Avatar>
                  {record.creatorId}
                </div>
                <div className={"flex flex-col gap-2 w-full"}>
                  {record.details.map(
                    (item: {
                      categoryId: string;
                      content: string;
                      uuid: string;
                    }) => {
                      return (
                        <div key={item.uuid} className={"flex gap-2"}>
                          <span className={"font-bold self-start"}>
                            {
                              categories.find(
                                (category) => category.uuid === item.categoryId
                              )?.name
                            }
                            :
                          </span>
                          <span
                            className={"break-all flex-1"}
                            style={
                              {
                                textWrap: "wrap",
                              } as any
                            }
                          >
                            {item.content}
                          </span>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      />
      <Popup
        visible={calendarModal}
        closeOnMaskClick={true}
        onClose={() => {
          setCalendarModal(false);
        }}
      >
        <CalendarPickerView
          onChange={
            ((date: any) => {
              if (!date) {
                setDate("");
                setCalendarModal(false);
              } else {
                const yyyyMMdd = dayjs(date).format("YYYY-MM-DD");
                setDate(yyyyMMdd);
                setCalendarModal(false);
              }
            }) as any
          }
          renderDate={(date) => {
            if (reportDates.includes(dayjs(date).format("YYYY-MM-DD"))) {
              return (
                <div
                  className={
                    "w-8 h-8 bg-blue-500 rounded-full text-center text-white leading-[32px]"
                  }
                >
                  {date.getDate()}
                </div>
              );
            }

            if (
              !reportDates.includes(dayjs(date).format("YYYY-MM-DD")) &&
              dayjs(date).isBefore(dayjs().startOf("day"))
            ) {
              return (
                <div
                  className={
                    "w-8 h-8 bg-red-500 rounded-full text-center text-white leading-[32px]"
                  }
                >
                  {date.getDate()}
                </div>
              );
            }

            return <div>{date.getDate()}</div>;
          }}
        />
      </Popup>
      <Popup
        bodyStyle={{ height: "100vh" }}
        closeOnMaskClick={true}
        onClose={() => {
          setReportModal({
            ...reportModal,
            open: false,
          });
        }}
        visible={reportModal.open}
      >
        <NavBar
          back={
            <Button
              fill={"none"}
              size={"small"}
              onClick={() => {
                setReportModal({
                  ...reportModal,
                  open: false,
                });
              }}
            >
              取消
            </Button>
          }
          backArrow={false}
          right={
            <Button
              fill={"none"}
              size={"small"}
              onClick={() => {
                if (reportModal.uuid) {
                  instance
                    .post("/custom/laiensi/updateDailyReport", {
                      uuid: reportModal.uuid,
                      detailsJSON: JSON.stringify(
                        reportModal.details.map((item) => ({
                          categoryId: item.categoryId,
                          content: item.content,
                        }))
                      ),
                    })
                    .then((res) => {
                      if (res.data.Status === "1") {
                        Toast.success("提交成功");
                        setReportModal({
                          ...reportModal,
                          open: false,
                        });
                        listRef.current?.refresh();
                        // 获取今天的日报，用于判断点击新建按钮时是否需要跳转到编辑界面
                        // getCurrentDailyReport
                        instance
                          .get("/custom/laiensi/getCurrentDailyReport")
                          .then((res) => {
                            if (!res.data.Data) {
                              return;
                            }
                            setCurrentReport(res.data.Data);
                          });
                      } else {
                        Toast.fail("提交失败");
                      }
                    });
                } else {
                  instance
                    .post("/custom/laiensi/createDailyReport", {
                      date: dayjs().format("YYYY-MM-DD"),
                      detailsJSON: JSON.stringify(
                        reportModal.details.map((item) => ({
                          categoryId: item.categoryId,
                          content: item.content,
                        }))
                      ),
                    })
                    .then((res) => {
                      if (res.data.Status === "1") {
                        Toast.success("提交成功");
                        setReportModal({
                          ...reportModal,
                          open: false,
                        });
                        listRef.current?.refresh();
                      } else {
                        Toast.fail("提交失败");
                      }
                    });
                }
              }}
            >
              提交
            </Button>
          }
        >
          工作日志
        </NavBar>
        <div className={"flex gap-2 flex-col w-full px-4"}>
          <span className={"text-lg font-bold"}>
            {dayjs().format("YYYY-MM-DD")}
          </span>
          <div
            className={
              "bg-gray-100 rounded pb-2 pt-4 px-4 pb-4 gap-1 w-full flex flex-col"
            }
          >
            {reportModal.details.map((item) => (
              <div
                key={item.categoryId}
                className={"flex items-center w-full gap-1"}
              >
                <span className={"font-bold self-start mt-0.5"}>
                  {
                    categories.find(
                      (category) => category.uuid === item.categoryId
                    )?.name
                  }
                  :
                </span>
                <TextArea
                  placeholder={"请输入内容"}
                  onKeyDown={(e: any) => {
                    // 如果按下的是 Backspace 并且内容为空，并且不是最后一个标签，就删除当前标签
                    if (
                      e.keyCode === 8 &&
                      e.target.value === "" &&
                      reportModal.details.length > 1
                    ) {
                      setReportModal((prevState) => {
                        return {
                          ...prevState,
                          details: prevState.details
                            .filter(
                              (detail) => detail.categoryId !== item.categoryId
                            )
                            .map((detail, index) => {
                              if (index === 0) {
                                // 如果是第一个标签，就让第一个标签获得焦点
                                return {
                                  ...detail,
                                  focus: true,
                                };
                              }

                              // 如果不是第一个标签，就让其他标签失去焦点
                              return {
                                ...detail,
                                focus: false,
                              };
                            }),
                        };
                      });
                    }
                  }}
                  autoSize={true}
                  className={
                    "flex-1 border-none bg-transparent outline-0 [&_textarea]:text-sm"
                  }
                  autoFocus={item.focus}
                  value={item.content}
                  onChange={(e) => {
                    const content = e;
                    setReportModal((prevState) => {
                      return {
                        ...prevState,
                        details: prevState.details?.map((detail) => {
                          return detail.categoryId === item.categoryId
                            ? {
                                ...detail,
                                content,
                              }
                            : detail;
                        }),
                      };
                    });
                  }}
                />
              </div>
            ))}
          </div>
          <div className={"flex gap-2 items-center"}>
            <svg
              width="6"
              height="14"
              viewBox="0 0 6 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 6.92911C6 3.40264 3.39229 0.48523 0 0V13.8582C3.39229 13.373 6 10.4556 6 6.92911Z"
                fill="#345BF0"
              />
            </svg>
            <span className={"font-bold"}>标签</span>
          </div>
          <div className={"flex items-center gap-2"}>
            {categories
              .filter(
                (item) =>
                  !reportModal.details.find(
                    (detail) => detail.categoryId === item.uuid
                  )
              )
              .map((item) => (
                <Tag
                  className={"cursor-pointer"}
                  key={item.uuid}
                  onClick={() => {
                    setReportModal((prevState) => ({
                      ...prevState,
                      details: [
                        ...prevState.details.map((detail) => ({
                          ...detail,
                          focus: false,
                        })),
                        {
                          categoryId: item.uuid,
                          content: "",
                          focus: true,
                        },
                      ],
                    }));
                  }}
                >
                  {item.name}
                </Tag>
              ))}
            {
              // 如果没有标签了，就不显示
              categories.length === reportModal.details.length ? (
                <span className={"text-gray-500"}>没有更多标签了</span>
              ) : (
                <></>
              )
            }
          </div>
        </div>
      </Popup>
      <Button
        color={"primary"}
        className={"w-[40px] fixed right-2 bottom-2"}
        shape={"rounded"}
        onClick={() => {
          if (currentReport) {
            setReportModal({
              ...reportModal,
              open: true,
              ...currentReport,
            });
            return;
          }

          setReportModal({
            ...reportModal,
            open: true,
            date: dayjs().format("YYYY-MM-DD"),
            details: [
              {
                categoryId: categories[0].uuid,
                content: "",
                focus: true,
              },
            ],
          });
        }}
      >
        +
      </Button>
    </>
  );
}
